import { render, staticRenderFns } from "./BrandToggleButtonFormRadius.vue?vue&type=template&id=1a4064f4&"
import script from "./BrandToggleButtonFormRadius.vue?vue&type=script&lang=ts&"
export * from "./BrandToggleButtonFormRadius.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports